import styled from 'styled-components'

const ErrorDiv = styled.div`
  background-color: ${p => p.theme.color.red.tint75};
  padding: 16px;
  display: flex;
  align-items: center;
  svg {
    flex: 0 0 3.4rem;
    g {
      stroke: ${p => p.theme.color.background.primary};
    }
  }
  > p {
    font-weight: ${p => p.theme.font.weight.light};
    font-size: ${p => p.theme.font.size.body};
    color: ${p => p.theme.color.background.primary};
    margin: 0 0 0 16px;
  }
`

const ErrorMessage = ({ children }) =>
  children ? (
    <ErrorDiv>
      <svg width="34" height="34" viewBox="0 0 34 34" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd" strokeLinejoin="round">
          <path
            d="M33.258 16.719c.157 8.98-7.278 16.388-16.258 16.544C8.021 33.418.897 26.265.742 17.285.585 8.307 8.021.897 17 .74c8.979-.156 16.103 7 16.258 15.978zM17 19.217V8.87"
            strokeLinecap="round"
          />
          <path d="M17.74 24.391a.74.74 0 1 1-1.48 0 .74.74 0 0 1 1.48 0z" />
        </g>
      </svg>
      <p aria-live="polite">{children}</p>
    </ErrorDiv>
  ) : null

export default ErrorMessage
